import axios from 'axios'
import { SESSION_STORAGE_CHAVE_USER } from '@/config/constantes'
import keycloak, {
  atualizarToken,
  logout,
  salvarRotaPosLogin,
} from '@/config/keycloak'

const servicoBase = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

let deslogandoPorSessaoInvalida = false

const deslogarPorSessaoInvalida = (): void => {
  if (deslogandoPorSessaoInvalida) return
  deslogandoPorSessaoInvalida = true

  sessionStorage.removeItem(SESSION_STORAGE_CHAVE_USER)
  salvarRotaPosLogin()
  logout()
}

servicoBase.interceptors.request.use(async config => {
  if (keycloak.authenticated) {
    try {
      await atualizarToken()
    } catch (error) {
      deslogarPorSessaoInvalida()
      throw error
    }

    config.headers = config.headers ?? {}
    config.headers.Authorization = `Bearer ${keycloak.token}`
  }

  return config
})

servicoBase.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      deslogarPorSessaoInvalida()
    }

    return Promise.reject(error)
  }
)

export { servicoBase }
